/* app/js/src/components/alerts/alert-settings/alert-settings.component.scss */
.content ul {
  padding: 0;
  margin: 0;
  list-style-type: none;
}
.cursor-pointer {
  cursor: pointer;
}
.content {
  color: #ffffff;
  font-size: 0.9em;
}
.content ul {
  margin: 10px;
}
.content ul li {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
}
.content ul li .find-alerts-header {
  line-height: 23px;
  font-size: 11px;
  padding-left: 8px;
  padding-right: 8px;
}
.content ul li > .switcher {
  -ms-transform: scale(0.55, 0.55);
  -webkit-transform: scale(0.55, 0.55);
  transform: scale(0.55, 0.55);
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
}
.title-class {
  text-align: left !important;
}
.switchers {
  margin-top: 20px !important;
}
.switchers .switcher-title {
  line-height: 25px;
  font-size: 11px;
}
.daysFilter {
  width: 184px;
  margin-left: 5px;
  height: 23px;
  background-color: #141b22;
  border: 0;
}
.footer {
  float: right;
  margin-bottom: 10px;
}
/*# sourceMappingURL=alert-settings.component.css.map */
